<div bsModal #visitReportModal="bs-modal" class="eup-modal modal fade" [config]="{backdrop: 'static', keyboard: false}">
  <div class="modal-dialog modal-lg">
    <div class="modal-content" #visitReportContainer>
    </div>
  </div>
</div>